module.exports = __webpack_public_path__ + "static/media/slider-authentic-studio-slide-01-bg.e9a8dbf3.jpg";